var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 20,
  viewBox: "0 0 14 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-5661.001 6033)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.581,1,13.953,5.892H10.789L8,1Z",
  transform: "translate(5655.71 -6034)",
  fill: "#d84315"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.1,8.746,8.336,10a7.275,7.275,0,0,0-3.624,1.325L1.47,5.917a.819.819,0,0,1,.008-.856L4.063,1l3.18,4.892Z",
  transform: "translate(5659.647 -6034)",
  fill: "#ff9801"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.3,5.892,7.121,1l-.605.951L9.078,5.892l1.855,2.854L10.171,10a7.242,7.242,0,0,0-2.727.782l.326.543A7.275,7.275,0,0,1,11.394,10l.762-1.252Z",
  transform: "translate(5656.589 -6034)",
  fill: "#f57c00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.585,5.917l-3.241,5.406A7.3,7.3,0,0,0,19.1,9.969c-.208,0-.416.008-.62.029l.762-1.252L21,5.892l3-4.892,2.585,4.061A.819.819,0,0,1,26.585,5.917Z",
  transform: "translate(5648.299 -6034)",
  fill: "#ff9801"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.485,23.062v0h.021Z",
  transform: "translate(5648.946 -6048.455)",
  fill: "#f57c00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.34,5.061,29.755,1l-.6.978,1.961,3.082a.819.819,0,0,1,.008.856L28.21,10.779a7.406,7.406,0,0,1,.9.544l3.241-5.406a.819.819,0,0,0-.008-.856Z",
  transform: "translate(5642.536 -6034)",
  fill: "#f57c00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.473,30.339a7.078,7.078,0,0,1-6.545,7.338A7,7,0,0,1,2.01,30.755a7.161,7.161,0,0,1,6.157-7.726A5.267,5.267,0,0,1,8.736,23c3.72,0,6.735,3.286,6.736,7.338Z",
  transform: "translate(5659.264 -6050.679)",
  fill: "#ffdc00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.356,24.354A7.3,7.3,0,0,0,19.112,23c-.2,0-.4.009-.6.028A7.335,7.335,0,0,1,18.5,37.646c.2.017.405.031.612.031a7.338,7.338,0,0,0,4.244-13.323Z",
  transform: "translate(5648.287 -6050.679)",
  fill: "#fec108"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.492,32.15l.81,1.722a.254.254,0,0,0,.191.144l1.816.277a.265.265,0,0,1,.141.446l-1.319,1.349a.268.268,0,0,0-.072.23l.311,1.9a.255.255,0,0,1-.367.275L15.385,37.6a.245.245,0,0,0-.238,0l-1.618.892a.255.255,0,0,1-.369-.275l.311-1.9a.268.268,0,0,0-.072-.23L12.08,34.739a.265.265,0,0,1,.141-.446l1.816-.277a.254.254,0,0,0,.191-.144l.81-1.722a.25.25,0,0,1,.454,0Z",
  transform: "translate(5652.736 -6055.057)",
  fill: "#f5f5f5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.115,46.523A6.122,6.122,0,0,1,5,40.408a.408.408,0,0,1,.815,0,5.306,5.306,0,0,0,5.3,5.3.408.408,0,0,1,0,.815Z",
  transform: "translate(5657.487 -6060.749)",
  fill: "#ff9801"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.115,32.523a.408.408,0,0,1-.408-.408,5.306,5.306,0,0,0-5.3-5.3.408.408,0,1,1,0-.815,6.122,6.122,0,0,1,6.115,6.115A.408.408,0,0,1,25.115,32.523Z",
  transform: "translate(5647.991 -6050.979)",
  fill: "#ff9801"
}))));
export default __webpack_public_path__ + "static/media/best-seller.3402d60f.svg";
export { SvgComponent as ReactComponent };